import {Component} from '@angular/core';

@Component({
    selector: 'app-contact-support-help',
    templateUrl: './contact-support-help.component.html',
    styleUrls: ['../../../../styles/standard-elements.scss', './contact-support-help.component.scss'],
    standalone: false
})
export class ContactSupportHelpComponent {

}


